<template>
    <div class="dailyReport-container">
        <div class="watermark" :style="{ backgroundImage: watermarkText }"></div>
        <headline @search="headSearch" :params="headLines" :isSearchResult="isSearchResult" :searchKeyWord="keyWord">
        </headline>
        <div class="dailyReport-bg">
            <div class="dailyReport-head">
                <ul class="menu">
                    <li :class="{ 'cur': menuIndex == index }" @click="onClickMenu(index)"
                        v-for="(item, index) in channelList" :key="item.id">
                        {{ item.value }}
                        <div class="bar"></div>
                    </li>
                </ul>
            </div>
            <div :style="'font-size:' + fontSize + 'px'" class="dailyReport-content">
                <div class="btn">
                    <div class="resultSearch">
                        <div class="left" v-if="channelList.length > 0">
                            <p v-for="(item, index) in channelList[menuIndex].child_list" @click="onClickChannel(index)"
                                :key="index" :class="{ on: channelIndex === index }">
                                {{ item.value }}</p>
                        </div>
                        <div class="right">
                            <div class="date-label">选择日期</div>
                            <date-picker class="date-picker" v-model="datePicker" calendar-icon="none" :editable="false"
                                :clearable="true" :shortcuts="false" confirm :not-before="notBeforeDate"
                                :not-after="notAfterDate">
                            </date-picker>
                            <a class="async" v-if="enableAsync" @click="clickAsync"></a>
                        </div>
                    </div>
                </div>

                <ul class="list-content" ref="list">
                    <li class="list-head">
                        <div class="num">序号</div>
                        <div v-for="keyItem in curTemp" :class="keyItem" :key="keyItem">
                            <template
                                v-if="keyItem == 'live_watch_cnt' || keyItem == 'live_comment_cnt' || keyItem == 'live_digg_cnt' || keyItem == 'live_share_cnt'">
                                <a :class="{ 'sort': true, 'sort-up': sortBy == keyItem && !sortDesc, 'sort-down': sortBy == keyItem && sortDesc }"
                                    @click="sort_by(keyItem)">
                                    {{ dataMap[keyItem] }}
                                </a>
                            </template>
                            <template v-else>
                                {{ dataMap[keyItem] }}
                            </template>
                        </div>
                        <div class="control" v-if="tempEditable && showEditer">操作</div>
                    </li>
                    <template v-if="dataList.length == 0">
                        <div class="empty">
                            <img src="@assets/img/material/box.svg" alt="">
                            <span>暂无内容</span>
                        </div>
                    </template>
                    <template v-else>
                        <li v-for="(item, index) in dataList" :key="item.id" class="list-item">
                            <div class="num">{{ index + 1 }}</div>
                            <div v-for="keyItem in curTemp" :class="keyItem" :key="keyItem">
                                <template v-if="keyItem == 'editor'">
                                    <el-input v-if="item.showEdited" maxlength="20" v-model="item.editor"
                                        style="width: 110px;"></el-input>
                                    <el-tooltip placement="top" v-else>
                                        <div slot="content">{{ item[keyItem] }}</div>
                                        <span>{{ item[keyItem] }}</span>
                                    </el-tooltip>
                                </template>
                                <template v-else-if="keyItem == 'depart'">
                                    <el-select v-if="item.showEdited" v-model="item.department_name" placeholder="请选择单位"
                                        class="confirm-item-value" style="width: 134px;">
                                        <el-option v-for="depart in departList" :key="depart.depart_name"
                                            :label="depart.depart_name" :value="depart.depart_name"></el-option>
                                    </el-select>
                                    <el-tooltip placement="top" v-else>
                                        <div slot="content">{{ item[keyItem] }}</div>
                                        <span>{{ item[keyItem] }}</span>
                                    </el-tooltip>
                                </template>
                                <template v-else-if="(keyItem == 'orgnize_name') || (keyItem == 'title')">
                                    <el-tooltip placement="top">
                                        <div slot="content">{{ item[keyItem] }}</div>
                                        <span>{{ item[keyItem] }}</span>
                                    </el-tooltip>
                                </template>
                                <template v-else-if="showNumStr.includes(keyItem)">
                                    {{ Number(item[keyItem]).toLocaleString() }}
                                </template>
                                <template v-else>
                                    {{ item[keyItem] }}
                                </template>
                            </div>
                            <div class="control" v-if="tempEditable && showEditer">
                                <button @click="editItem(item)" v-if="!item.showEdited">
                                    编辑
                                </button>
                                <button @click="saveEditer(item)" v-else>
                                    完成
                                </button>
                            </div>
                        </li>
                    </template>
                </ul>
                <div class="list-info">
                    <h3>数据说明</h3>
                    <div class="cont" v-html="dataTips">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import headline from "@components/headline";
import common from "@common/common";
import vClickOutside from "v-click-outside";
import pages from "@components/pages";
import empty from "@components/empty";
import skeleton from "@components/skeleton";
import DatePicker from "vue2-datepicker";
import DOMPurify from "isomorphic-dompurify";

const apiRoot = process.env.NODE_ENV === "development" ? "" : window.location.origin;

const dailyConfig = apiRoot + "/index.php?r=datacenter/dailyreport/config";
const dailyList = apiRoot + "/index.php?r=datacenter/dailyreport/list";
const dailySync = apiRoot + "/index.php?r=datacenter/dailyreport/sync";
const dailySave = apiRoot + "/index.php?r=datacenter/dailyreport/save";
const dailyDepart = apiRoot + "/index.php?r=datacenter/dailyreport/departlist";
const dataTipsConfig = apiRoot + "/index.php?r=datacenter/dailyreport/datatips";

export default {
    directives: {
        clickOutside: vClickOutside.directive
    },
    components: {
        pages,
        empty,
        DatePicker,
        skeleton,
        headline
    },
    data() {
        return {
            controller: null,
            showSearchBox: false,
            headLines: {
                title: "数据日报",
                showLink: false,
                filter: false
            },
            fontSize: 100,
            dataList: [],
            saveList: [],
            keyWord: '',
            searchDate: '',
            quickEdit: true,
            create: {
                interview: false,
                material: false,
                publish: false,
                report: false
            },
            page: {
                pageCount: 0,
                pageIndex: 1,
                pageSize: 100,
                total: 0
            },
            searchBox: {},
            isSearchResult: false,
            datePicker: '',
            menuIndex: 0,
            channelIndex: 0,
            channelList: [],
            departList: [],
            editIndex: -1,
            sortBy: '',
            sortDesc: false,
            dataTips: '',
            showEditer: false,
            tempEditable: false,
            enableAsync: false,
            watermarkText: '',

            dataMap: {
                sort: '序号',
                id: '编号',
                title: '标题',
                orgnize_name: '机构名称',
                media_id: '平台类型id',
                media_name: '平台类型名称',
                publish_date: '发布时间',
                editor: '编辑',
                depart: '部门',
                live_watch_ucnt: '观看人数',
                live_watch_cnt: '浏览量',
                live_per_view_duration: '人均观看时长',
                live_comment_cnt: '评论量',
                live_digg_cnt: '点赞量',
                live_digg_ucnt: '点赞人数',
                live_share_cnt: '分享转发量',
                live_new_fans_ucnt: '新增粉丝量',
                reportor: '记者',
                content_publish_time: '发布时间',
                view_duration: '视频时长',
                kankan_name: '看看号名称',
                sum_play_num: '观看次数',
                user_num: '观看用户数',
                avg_cnt: '平均次数',
                avg_duration_min: '平均时长',
            },

            showNumStr: ['live_watch_ucnt',
                'live_watch_cnt',
                'live_comment_cnt',
                'live_digg_cnt',
                'live_digg_ucnt',
                'live_share_cnt',
                'live_new_fans_ucnt',
                'sum_play_num',
                'user_num',
                'avg_cnt'
            ],

            curTemp: [],
            normalTemp: ["title", "orgnize_name", "publish_date", "editor", "depart", "live_watch_cnt", "live_comment_cnt", "live_digg_cnt", "live_share_cnt"],
            kankanTemp: ["title", "kankan_name", "content_publish_time", "depart", "editor", "reportor", "live_watch_cnt", "live_share_cnt", "view_duration"],
            kankanLiveTemp: ["title", "sum_play_num", "user_num", "avg_cnt", "avg_duration_min"],
            thirdLiveTemp: ["media_name", "live_watch_ucnt", "live_watch_cnt", "live_per_view_duration", "live_share_cnt", "live_digg_cnt", "live_comment_cnt", "live_new_fans_ucnt"],
            douyinTemp: ["title", "live_watch_cnt", "live_watch_ucnt", "live_digg_cnt", "live_comment_cnt", "live_new_fans_ucnt"],
            kuaiTemp: ["title", "live_watch_ucnt", "live_digg_cnt", "live_digg_ucnt", "live_comment_cnt", "live_share_cnt"],
            shipingTemp: ["title", "sum_play_num", "live_watch_ucnt", "live_digg_cnt", "live_comment_cnt", "live_share_cnt", "avg_duration_min", "live_new_fans_ucnt"],

            notBeforeDate: new Date('2025-04-01'), // 设置可选日期的最早日期
            notAfterDate: new Date(),
        }
    },
    watch: {
        datePicker: {
            deep: true,
            handler: function (n) {
                this.page.pageIndex = 1;
                this.searchDate = this.stampToDate(n);

                if (this.channelList.length > 0) {
                    this.getList();
                }
            }
        },
        "$store.state.tag": function (e) {
            this.navigateSearch(e)
        }
    },
    methods: {
        disabledDate(date) {
            // 如果日期早于 startDate 或晚于 endDate，则禁用
            const startDate = new Date(2025, 4, 1); // 月份从 0 开始（0=1月）
            const endDate = new Date();
            return endDate;
        },
        sort_by(targetSortBy) {
            if (this.sortBy == targetSortBy && this.sortDesc) {
                this.sortBy = '';
                this.sortDesc = false;
            }
            else {
                this.sortDesc = targetSortBy == this.sortBy ? !this.sortDesc : false;
                this.sortBy = targetSortBy;
            }
            this.getList();
        },

        getYesterday() {
            // 获取当日时间戳
            const today = +new Date()
            const yesterday = new Date(today - 24 * 60 * 60 * 1000)
            return yesterday
        },
        stampToDate(s) {
            // 将时间戳转换为时间
            if (!s) {
                return "";
            }

            const year = s.getFullYear();
            const month = this.doubleDigit(s.getMonth() + 1);
            const day = this.doubleDigit(s.getDate());

            return `${year}-${month}-${day}`;
        },
        doubleDigit(n) {
            // 将数字转为两位，不足补零
            if (n / 10 < 1) {
                return `0${n}`;
            }

            return `${n}`;
        },
        onClickMenu(index) {
            this.menuIndex = index;
            this.channelIndex = 0;
            this.sortBy = '';
            this.sortDesc = true;
            this.getList();
        },

        onClickChannel(index) {
            this.channelIndex = index;
            this.sortBy = '';
            this.sortDesc = true;
            this.getList();
        },
        headSearch(title) {
            this.keyWord = title;
            this.page.pageIndex = 1;
            this.getList();
        },
        navigateSearch(title) {
            this.isSearchResult = true;
            this.showSearchBox = false;
            this.keyWord = title;
            this.page.pageIndex = 1;
            this.getList();
        },
        getConfig() {
            this.datePicker = this.getYesterday();
            common.myFetch(dailyConfig, {}).then(res => {
                if (res) {
                    this.channelList = res.channel_list;
                    this.showEditer = res.has_edit_role === true; // 使用全等判断

                    this.menuIndex = 0;
                    this.channelIndex = 0;
                    this.getList();
                }
            });
        },
        getList() {
            if (this.controller) {
                this.controller.abort(); // 终止之前的请求
            }

            this.controller = new AbortController(); // 创建新的 AbortController
            const signal = this.controller.signal; // 获取信号
            let channelID = '';
            if (this.channelList[this.menuIndex].child_list.length > this.channelIndex) {
                channelID = this.channelList[this.menuIndex].child_list[this.channelIndex].id;
            }
            let data = {
                media_id: this.channelList[this.menuIndex].id,
                channel_id: channelID,
                date: this.searchDate
            };

            if (data.media_id == '999') {
                this.curTemp = this.kankanTemp;
            }
            else if (data.media_id == '9999') {
                if (data.channel_id == '999') {
                    this.curTemp = this.kankanLiveTemp;
                }
                else if (data.channel_id == '0') { // 第三方总榜
                    this.curTemp = this.thirdLiveTemp;
                }
                else if (data.channel_id == '5') { // 抖音
                    this.curTemp = this.douyinTemp;
                }
                else if (data.channel_id == '2') { // 微信视频号
                    this.curTemp = this.shipingTemp;
                }
                else if (data.channel_id == '6') { // 快手
                    this.curTemp = this.kuaiTemp;
                }
            }
            else {
                this.curTemp = this.normalTemp;
            }

            if (data.media_id == '5' || data.media_id == '2' || data.media_id == '6' || data.media_id == '7') {
                this.tempEditable = true;
                this.enableAsync = true;
            }
            else {
                this.tempEditable = false;
                this.enableAsync = false;
            }

            if (this.sortBy.length > 0) {
                data.sort_by = this.sortBy;
                data.sort_desc = !this.sortDesc ? 1 : 0;
            }

            common.myFetch(dailyList, { data: data, signal: signal }).then(res => {
                if (res) {

                    res.forEach((el) => {
                        el.showEdited = false;
                    });

                    this.dataList = res;
                }
            });

            let tipsInfo = {
                media_id: this.channelList[this.menuIndex].id,
                channel_id: channelID,
            };

            common.myFetch(dataTipsConfig, { data: tipsInfo }).then(res => {
                if (res) {
                    this.dataTips = DOMPurify.sanitize(res.data_tips);
                }
            });
        },
        async clickAsync() {

            const msg = `操作手动更新数据后，当前已维护的编辑、部门字段将不保留`
            const c = await this.$confirm(msg)
            if (!c) return


            let data = {
                media_id: this.channelList[this.menuIndex].id,
                channel_id: this.channelList[this.menuIndex].child_list[this.channelIndex].id,
                date: this.searchDate
            };

            common.myFetch(dailySync, data).then(res => {
                if (res) {
                    this.$toast("手动更新成功");
                    this.getList()
                }
            });

        },

        getDepartment() {
            common.myFetch(dailyDepart).then(res => {
                if (res) {
                    this.departList = res.list;
                }
            });
        },

        editItem(item) {
            item.showEdited = true;
        },
        saveEditer(item) {
            let channelID = '';
            if (this.channelList[this.menuIndex].child_list.length > this.channelIndex) {
                channelID = this.channelList[this.menuIndex].child_list[this.channelIndex].id;
            }
            let data = {
                media_id: this.channelList[this.menuIndex].id,
                channel_id: channelID,
                id: item.id,
                editor: item.editor,
                depart_name: item.department_name || '',
            };

            common.myFetch(dailySave, data).then(res => {
                if (res) {
                    this.$toast("保存成功");
                    this.getList()
                }
            });

            item.showEdited = false;
        },
        async updateWatermark(userName) {
            const now = new Date();
            const formattedDate = `${now.getFullYear()}-${this.doubleDigit(now.getMonth() + 1)}-${this.doubleDigit(now.getDate())} ${this.doubleDigit(now.getHours())}:${this.doubleDigit(now.getMinutes())}:${this.doubleDigit(now.getSeconds())}`;

            const svg = `<svg xmlns="http://www.w3.org/2000/svg" version="1.1" width="300" height="200">
                            <text x="10" y="80" font-family="Arial" font-size="20" fill="#aaa" transform="rotate(-45, 150, 100)">
                                <tspan x="10" dy="0">${userName}</tspan>
                                <tspan x="10" dy="25">${formattedDate}</tspan>
                            </text>
                          </svg>`;
            const encodedSvg = encodeURIComponent(svg);
            const backgroundImage = `url('data:image/svg+xml;utf8,${encodedSvg}')`;

            this.watermarkText = backgroundImage;
        },
        async getUserTrueName() {
            // 获取用户信息数据
            const r = await common.getUserInfo()
            if (r && r.truename) {
                this.updateWatermark(r.truename);
            }
            else {
                this.updateWatermark('Xnews');
            }
        }
    },
    mounted() {

        this.getConfig();
        this.getDepartment();
        this.updateWatermark(); // 更新水印文本
        this.getUserTrueName();

    },
    created() {
        this.create = this.$store.state.create;
        this.quickEdit = this.$store.state.quickEdit;
    }
}
</script>

<style lang="less" scoped src="./dailyReport.less"></style>
<style lang="less" scoped>
.watermark {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    /* 防止水印干扰用户交互 */
    z-index: 999;
    /* 确保水印在最上层 */
    background-repeat: repeat;
    background-size: 300px 200px;
    opacity: 0.5;
    /* 调整透明度 */
}
</style>